import React from "react";
import classNames from "lib/classNames";

const GuideVideo = ({ label, link = "", image }) => {
  return (
    <a
      className={classNames("mb-3")}
      href={link}
      style={{ width: "30%" }}
      target="_blank"
    >
      <div
        style={{
          backgroundImage: `url(${image})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
          width: "100%",
          height: "110px",
        }}
      ></div>
      {/* <iframe
        width="100%"
        height="110px"
        src={link}
        title={label}
        frameBorder="0"
        allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe> */}
      <p
        className={classNames("text-gray-600 text-sm mt-2 text-center")}
        style={{ lineHeight: "19px" }}
      >
        {label}
      </p>
    </a>
  );
};

export default GuideVideo;
